import { InternalGroupModel } from './internal-group.model';

export namespace LifestyleModel {
    export type Lifestyle = InternalGroupModel.InternalGroup;
}
